import { createUseStyles } from "react-jss";
import { theme } from "$utils/theme/bataillog";

export const useCommonStyles = createUseStyles(() => ({
  ProjectsPage_Popin: {
    "& .MuiDrawer-paper": {
      width: "70% !important",
      overflowY: "unset !important",
    },
    "& .bordered": {
      display: "flex",
      alignItems: "center",
      borderTop: "1px solid #d8dadc",
      "& h3:not(:first-child)": {
        marginLeft: "10px",
      },
    },
  },
  ProjectsPage: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    border: "0px",
    "& td.MuiTableCell-body:first-child": {
      fontWeight: "bold",
    },
    "& .MuiTableContainer-root": {
      boxShadow: "unset",
    },
    "& .MuiIconButton-label": {
      transform: "scale(0.6) !important",
    },
  },
  SwitchControl: {
    "& .MuiTypography-body1": {
      fontSize: "14px",
    },
  },
  ProjectsPage__AddCta: {
    marginRight: "10px !important",
  },
  TableRowCode: {
    "& > div span": {
      color: theme.color.blue,
    },
    "&.disabled": {
      "& span": {
        color: `${theme.color.gray3} !important`,
      },
    },
  },
  RowBold: {
    "& span": {
      fontWeight: "500",
    },
    "&.disabled": {
      "& span": {
        color: `${theme.color.gray3} !important`,
      },
    },
  },
  select: {
    flex: "1",
    paddingRight: "20px",
    "&:last-child": {
      padding: 0,
    },
    // background: theme.color.white,
    "& .MuiInputLabel-shrink": {
      // background: `${theme.color.white} !important`,
    },
  },
  tabHeader: {
    borderBottom: `1px solid ${theme.color.gray2}`,
  },
  loaderIcon: {
    marginRight: "8px",
  },
  ReceptionPopin: {
    "& .MuiDrawer-paper": {
      width: "90% !important", // Larger width for reception
      maxWidth: "1200px !important",
      overflowY: "unset !important",
    },
  },
  OrderFormContainer: {
    maxWidth: "1000px",
    width: "100%",
    margin: "0 auto",
    boxSizing: "border-box",
  },
}));
